import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const CustomerIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2ZM9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 13C8.98248 13 6.91739 13.7892 5.52442 14.8097C4.13956 15.8243 3.49348 17.0127 3.21567 17.6991C3.03453 18.1467 3 18.5923 3 18.9501C3 20.6345 4.36551 22 6.04995 22H17.9501C19.6345 22 21 20.6345 21 18.9501C21 18.5923 20.9655 18.1467 20.7843 17.6991C20.5065 17.0127 19.8604 15.8243 18.4756 14.8097C17.0826 13.7892 15.0175 13 12 13ZM5.06961 18.4494C5.24587 18.0139 5.69356 17.1651 6.70641 16.4231C7.71115 15.687 9.3477 15 12 15C14.6523 15 16.2888 15.687 17.2936 16.4231C18.3064 17.1651 18.7541 18.0139 18.9304 18.4494C18.9737 18.5564 19 18.7096 19 18.9501C19 19.5299 18.5299 20 17.9501 20H6.04995C5.47008 20 5 19.5299 5 18.9501C5 18.7096 5.02631 18.5564 5.06961 18.4494Z"
          fill="#006DFF"
        />
      </svg>
    );
  }
);

export default CustomerIcon;
